export default {
  contractTemplates: false,
  totalContractTemplate: 0,
  contractSettings: false,
  contract: false,
  contractTags: false,
};
